(function() {
    'use strict';

    angular.module("imApp").factory("templateService", [function() {
        var service = {

        }

        return service;
    }]);
})();
